import * as React from "react"
import { cn } from "@/lib/utils"

export interface AttachmentProps extends React.HTMLAttributes<HTMLDivElement> {}

const Attachment = React.forwardRef<HTMLDivElement, AttachmentProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex items-center gap-3 rounded-lg border border-zinc-200 bg-white p-3 shadow-xs dark:border-zinc-800 dark:bg-zinc-950 font-sans",
        className
      )}
      {...props}
    />
  )
)
Attachment.displayName = "Attachment"

const AttachmentMedia = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("flex size-9 shrink-0 items-center justify-center rounded-md bg-zinc-100 text-zinc-900 dark:bg-zinc-900 dark:text-zinc-50", className)}
      {...props}
    />
  )
)
AttachmentMedia.displayName = "AttachmentMedia"

const AttachmentContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("flex flex-1 flex-col gap-0.5 min-w-0", className)} {...props} />
  )
)
AttachmentContent.displayName = "AttachmentContent"

const AttachmentTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <p
      ref={ref}
      className={cn("text-xs font-semibold leading-none text-zinc-900 dark:text-zinc-50 truncate", className)}
      {...props}
    />
  )
)
AttachmentTitle.displayName = "AttachmentTitle"

const AttachmentDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p
      ref={ref}
      className={cn("text-[10px] text-zinc-500 dark:text-zinc-400 truncate", className)}
      {...props}
    />
  )
)
AttachmentDescription.displayName = "AttachmentDescription"

const AttachmentActions = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("flex items-center gap-1", className)} {...props} />
  )
)
AttachmentActions.displayName = "AttachmentActions"

const AttachmentAction = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        "flex size-7 items-center justify-center rounded-md text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-400 dark:hover:bg-zinc-900 dark:hover:text-zinc-50 transition-colors cursor-pointer",
        className
      )}
      {...props}
    />
  )
)
AttachmentAction.displayName = "AttachmentAction"

export {
  Attachment,
  AttachmentMedia,
  AttachmentContent,
  AttachmentTitle,
  AttachmentDescription,
  AttachmentActions,
  AttachmentAction,
}
